import { Password } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Alert, Box, Divider, TextField, Typography } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import { useFormik } from "formik";
import React from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { initiateRefundThunk } from "store/reducers/order/OrderSlice";
import * as yup from "yup";

const validation = yup.object({
  amount: yup
    .number("Enter a valid amount")
    .min(0, "Amount must be at least 0")
    .required("Amount is required"),
  password: yup
    .string("Authenticate  yourself")
    .required("Password is required"),
});

const RefundDialog = ({ order, open, handleClose }) => {
    // console.log("order", order);
  const formik = useFormik({
    initialValues: {
      amount: order.payable_amount,
      password: "",
    },
    validationSchema: validation,
    onSubmit: (data) => {
      console.log("data", data);
      dispatch(initiateRefundThunk({ id: order.id, data }));
    },
  });
  const state = useSelector((state) => state.order);
  return (
    <CustomDialog
      fullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Initiate Refund"
    >
      <Box paddingX={2}>
        <form onSubmit={formik.handleSubmit}>
          <Box display="flex" flexDirection="column" sx={{ mb: 2 }}>
            <TextField
              label="Amount to refund"
              variant="outlined"
              name="amount"
              fullWidth
              sx={{ mt: 3 }}
              value={formik.values.amount}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.amount)}
              helperText={formik.errors.amount}
              autoComplete="off"
              required
              type="number"
            />
            <Divider sx={{ my: 2 }} />
            <Typography color="red">
              **This action required authentication
            </Typography>
            <Divider sx={{ my: 2 }} />
            <TextField
              label="Password"
              variant="outlined"
              name="password"
              fullWidth
              value={formik.values.password}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.password)}
              helperText={formik.errors.password}
              autoComplete="new-password"
              required
              type="password"
            />

            {state.refund_status[order.id] &&
              state.refund_status[order.id].error_message && (
                <Alert sx={{ mt: 3 }} severity="error">
                  {state.refund_status[order.id].error_message}
                </Alert>
              )}
            {state.refund_status[order.id]?.success && (
              <Alert sx={{ mt: 3 }} severity="success">
                Success
              </Alert>
            )}
            <LoadingButton
                loading={state.refund_status[order.id]?.loading}
              variant="contained"
              sx={{ mt: 3, color: "white", backgroundColor: "orange" }}
              type="submit"
            >
              Initiate Refund
            </LoadingButton>
          </Box>
        </form>
      </Box>
    </CustomDialog>
  );
};

export default RefundDialog;
